/**
 * 계정 정보 일부를 가진 전역 store
 * - 유저 정보 중 name, userId, icafeIdList (이름, 유저id, 사업장 리스트)
 */

import { createWithEqualityFn } from "zustand/traditional";
import { devtools } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
import type { LoginInfoRawType } from "@features/auth/model/loginModel";

export interface IAccountStore {
  account: LoginInfoRawType | null;
  setAccount: (account: LoginInfoRawType | null) => void;
}

export const useAccountStore = createWithEqualityFn<IAccountStore>()(
  devtools(
    immer((set) => ({
      account: null,
      setAccount: (account: LoginInfoRawType | null) => set({ account }),
    })),
    {
      name: "ncfz-accountStore",
      enabled: process.env.NODE_ENV === "development", // 개발 환경에서만 활성화
    },
  ),
);
